// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import apiRequest from '@src/utility/BackendRequest'

// ** Axios Imports
import axios from 'axios'


export const updateLimit = createAsyncThunk('appEmail/updateLimit', async (limit) => {
  return limit
})

export const getMails = createAsyncThunk('appEmail/getMails', async params => {
  const response = await axios.get('/apps/email/emails', { params })
  return {
    params,
    data: response.data
  }
})

export const getTags = createAsyncThunk('appTodo/getTags', async () => {
  const response = await apiRequest.get('/tags', {params:{limit:100}})
  return response.data.results
})

export const getCases = createAsyncThunk('appTodo/getCases', async (params, {getState}) => {
  params = {...getState().email.params, ...params}
  params.page = 1
  if (params.tag === 'all') delete params.tag
  if (params.name && params.name.length < 3) delete params.name
  if (params.folio && params.folio.length > 0) delete params.name
  if (params.folio === '0' || params.folio === 0) delete params.folio
  const response = await apiRequest.get('/cases', {params})
  return {
    cases:response.data.results,
    params
  }
})

export const pageUpCases = createAsyncThunk('appTodo/pageUpCases', async (params, {getState}) => {
  params = {...getState().email.params, ...params}
  params.page = params.page + 1
  if (params.tag === 'all') delete params.tag
  if (params.name && params.name.length < 3) delete params.name
  const response = await apiRequest.get('/cases', {params})
  return {
    cases:response.data.results,
    params
  }
})

export const sendCase = createAsyncThunk('appTodo/sendCase', async (body, { dispatch }) => {
  const response = await apiRequest.post('/cases', body)
  await dispatch(getCases({populate:'tag,users', sortBy:'-createdAt', limit:10}))
  return response.data.results
})


export const updateMails = createAsyncThunk(
  'appEmail/updateMails',
  async ({ emailIds, dataToUpdate }, { dispatch, getState }) => {
    const response = await axios.post('/apps/email/update-emails', { emailIds, dataToUpdate })
    await dispatch(getMails(getState().email.params))
    return {
      emailIds,
      dataToUpdate,
      data: response.data
    }
  }
)

export const updateMailLabel = createAsyncThunk(
  'appEmail/updateMailLabel',
  async ({ tag, caseId }, {dispatch}) => {
    const response = await apiRequest.patch(`/cases/${caseId}`, {tag})
    await dispatch(getCases({populate:'tag,users', sortBy:'-createdAt', limit:10}))
    return response.data
  }
)

export const updateAsignees = createAsyncThunk(
  'appEmail/updateAsignees',
  async ({ users, caseId }) => {
    const response = await apiRequest.patch(`/cases/${caseId}`, {users})
    return response.data
  }
)

export const updateCase = createAsyncThunk(
  'appEmail/updateCase',
  async ({ data, caseId }) => {
    const response = await apiRequest.patch(`/cases/${caseId}`, data)
    return response.data
  }
)

export const deleteCase = createAsyncThunk('appEmail/deleteCase', async ({ caseId }, { dispatch }) => {
    const response = await apiRequest.delete(`/cases/${caseId}`)
    dispatch(getCases())
    return response.data
  }
)

export const paginateMail = createAsyncThunk('appEmail/paginateMail', async ({ dir, emailId }) => {
  const response = await axios.get('/apps/email/paginate-email', { params: { dir, emailId } })
  return response.data
})

export const selectCurrentMail = createAsyncThunk('appEmail/selectCurrentMail', async id => {
  const response = await apiRequest.get(`/cases/${id}`)
  return response.data
})

export const appEmailSlice = createSlice({
  name: 'appEmail',
  initialState: {
    mails: [],
    cases: [],
    params: {populate:'tag,users', sortBy:'-createdAt', limit:10, page:1},
    tags:[],
    emailsMeta: {},
    userData: JSON.parse((localStorage.getItem('rememberMe')==='true'?localStorage:sessionStorage).getItem('userData')),
    selectedMails: [],
    currentMail: null
  },
  reducers: {
    selectMail: (state, action) => {
      const selectedMails = state.selectedMails
      if (!selectedMails.includes(action.payload)) {
        selectedMails.push(action.payload)
      } else {
        selectedMails.splice(selectedMails.indexOf(action.payload), 1)
      }
      state.selectedMails = selectedMails
    },
    selectAllMail: (state, action) => {
      const selectAllMailsArr = []
      if (action.payload) {
        selectAllMailsArr.length = 0
        state.mails.forEach(mail => selectAllMailsArr.push(mail.id))
      } else {
        selectAllMailsArr.length = 0
      }
      state.selectedMails = selectAllMailsArr
    },
    resetSelectedMail: state => {
      state.selectedMails = []
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getMails.fulfilled, (state, action) => {
        let currMail = null
        if (state.currentMail !== null && state.currentMail !== undefined) {
          currMail = action.payload.data.emails.find(i => i.id === state.currentMail.id)
        }
        state.currentMail = currMail
        state.params = action.payload.params
        state.mails = action.payload.data.emails
        state.emailsMeta = action.payload.data.emailsMeta
      })
      .addCase(updateMails.fulfilled, (state, action) => {
        function updateMailData(email) {
          Object.assign(email, action.payload.dataToUpdate)
        }
        state.mails.forEach(email => {
          if (action.payload.emailIds.includes(email.id)) {
            updateMailData(email)
          }
        })
      })
      .addCase(paginateMail.fulfilled, (state, action) => {
        const data = action.payload
        const dataIndex = state.mails.findIndex(i => i.id === data.id)
        dataIndex === 0 ? (data.hasPreviousMail = false) : (data.hasPreviousMail = true)
        dataIndex === state.mails.length - 1 ? (data.hasNextMail = false) : (data.hasNextMail = true)
        state.currentMail = data
      })
      .addCase(selectCurrentMail.fulfilled, (state, action) => {
        state.currentMail = action.payload
      })
      .addCase(updateMailLabel.fulfilled, (state, action) => {
        state.currentMail = action.payload
      })
      .addCase(updateCase.fulfilled, (state, action) => {
        state.currentMail = action.payload
      })
      .addCase(updateAsignees.fulfilled, (state, action) => {
        state.currentMail = action.payload
      })
      .addCase(getTags.fulfilled, (state, action) => {
        state.tags = action.payload
      })
      .addCase(getCases.fulfilled, (state, action) => {
        state.cases = action.payload.cases
        state.params = action.payload.params
      })
      .addCase(pageUpCases.fulfilled, (state, action) => {
        state.cases = [...state.cases, ...action.payload.cases]
        state.params = action.payload.params
      })
      .addCase(updateLimit.fulfilled, (state, action) => {
        state.params.limit = action.payload
      })
  }
})

export const { selectMail, selectAllMail, resetSelectedMail } = appEmailSlice.actions

export default appEmailSlice.reducer
